<div class="container" [ngClass]="{backgdColor: true, 'text-blur': blur}" [ngStyle]="{ 'font-size': fontSize }">
  <div class="container-content">
    {{ content }}<sup *ngIf="indice">{{ indice }}</sup>
  </div>
</div>
